
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
@Component({
  components: {},
})
export default class BreadcrumbRegister extends Vue {
  @Prop({ default: 1 })
  private step!: number;
}
